import React, {
    useEffect,
    useState
}
from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import {
    faChevronLeft,
    faChevronRight
}
from "@fortawesome/free-solid-svg-icons";

import { DRAWER_BACKGROUND }
from "../../../../constants/styles";

import WorkspaceInsightsList
from "./WorkspaceInsightsList";

import WorkspaceInsightDetail
from "./WorkspaceInsightDetail";


import WorkspaceEvidenceList
from "./WorkspaceEvidenceList";


/*==========================================================
    WORKSPACE DRAWER
==========================================================*/

export default function WorkspaceDrawer(
{
    visible,
    onClose
})
{
    const LIST_WIDTH =
        400;

    const DETAIL_WIDTH =
        420;
		
	const EVIDENCE_WIDTH =
	        420;

    const HEADER_HEIGHT =
        64;

    const TRANSITION =
        "right .95s cubic-bezier(.16,1,.3,1)";

    const [detailVisible, setDetailVisible] =
        useState(false);
		
	const [evidenceVisible, setEvidenceVisible] =
	    useState(false);


    /*======================================================
        RESET DETAIL WHEN WORKSPACE CLOSES
    ======================================================*/

    useEffect(
        function ()
        {
            if (!visible)
            {
				setDetailVisible(false);
				setEvidenceVisible(false);
            }
        },
        [
            visible
        ]
    );


    /*======================================================
        CLOSE ENTIRE WORKSPACE
    ======================================================*/

	const closeWorkspace =
	    function ()
	    {
	        setEvidenceVisible(false);
	        setDetailVisible(false);

	        if (onClose)
	        {
	            onClose();
	        }
	    };


    return (

        <>

		{/*==================================================
		    EVIDENCE DRAWER

		    This sits beneath the Insight Detail drawer and
		    slides out when the user selects "Evidence".
		==================================================*/}

		<div
		    style={{
		        position: "fixed",

		        top: 0,

				right:
				    visible
				    && detailVisible
				    && evidenceVisible
				        ? `${LIST_WIDTH + DETAIL_WIDTH}px`
				        : `-${EVIDENCE_WIDTH}px`,

		        width: EVIDENCE_WIDTH + "px",

		        height: "100vh",

		        display: "flex",

		        flexDirection: "column",

		        overflow: "visible",

				background:
				    DRAWER_BACKGROUND,
				

		        backdropFilter:
		            "blur(14px)",

		        WebkitBackdropFilter:
		            "blur(14px)",

		        borderLeft:
		            "1px solid rgba(255,255,255,.06)",

		        boxShadow:
		            evidenceVisible
		                ? "-18px 0 48px rgba(0,0,0,.50)"
		                : "none",

		        transition:
		            TRANSITION,

		        zIndex: 4980,

				color:
				    "#1f2937"
		    }}
		>

		    {/* HEADER */}

		    <div
		        style={{
		            minHeight: HEADER_HEIGHT + "px",

		            display: "flex",

		            alignItems: "center",

		            justifyContent: "space-between",

		            padding: "0 18px 0 22px",

		            borderBottom:
		                "1px solid rgba(255,255,255,.08)",

		            background:
		                "rgba(0,0,0,.08)"
		        }}
		    >

		        <div>

		            <div
		                style={{
		                    color: "#ffffff",

		                    fontSize: "18px",

		                    fontWeight: 600
		                }}
		            >
		                Supporting Evidence
		            </div>

		            <div
		                style={{
		                    marginTop: "2px",

		                    color: "#7dd3fc",

		                    fontSize: "11px",

		                    fontWeight: 600,

		                    letterSpacing: ".7px",

		                    textTransform: "uppercase"
		                }}
		            >
		                Source documents
		            </div>

		        </div>

		        <button
		            type="button"

		            onClick={() =>
		                setEvidenceVisible(false)}

		            style={{
		                width: "36px",

		                height: "36px",

		                display: "flex",

		                alignItems: "center",

		                justifyContent: "center",

		                padding: 0,

		                border:
		                    "1px solid rgba(255,255,255,.10)",

		                borderRadius: "50%",

		                background:
		                    "rgba(255,255,255,.07)",

		                color: "#ffffff",

		                cursor: "pointer"
		            }}
		        >
		            <FontAwesomeIcon
		                icon={faChevronRight}
		            />
		        </button>

		    </div>


		    {/* BODY */}

		    <div
		        style={{
		            flex: 1,

		            minHeight: 0,

		            overflowY: "hidden",

		            overflowX: "hidden"
		        }}
		    >

		        <WorkspaceEvidenceList />

		    </div>

		</div>
		
            {/*==================================================
                DETAIL DRAWER

                This sits beneath the list drawer and slides
                left when an item is selected.
            ==================================================*/}

            <div
                style={{
                    position: "fixed",

                    top: 0,

					right:
					    visible
					    && detailVisible
					        ? `${LIST_WIDTH}px`
					        : `-${DETAIL_WIDTH}px`,

                    width: DETAIL_WIDTH + "px",
                    height: "100vh",

                    display: "flex",
                    flexDirection: "column",

                    overflow: "visible",

                    background:
                        DRAWER_BACKGROUND,

                    backdropFilter:
                        "blur(14px)",

                    WebkitBackdropFilter:
                        "blur(14px)",

                    borderLeft:
                        "1px solid rgba(255,255,255,.06)",

                    boxShadow:
                        detailVisible
                            ? "-18px 0 48px rgba(0,0,0,.50)"
                            : "none",

                    transition:
                        TRANSITION,

                    zIndex: 4990,

                    color: "#ffffff"
                }}
            >

                {/* DETAIL HEADER */}

                <div
                    style={{
                        minHeight: HEADER_HEIGHT + "px",

                        display: "flex",

                        alignItems: "center",
                        justifyContent: "space-between",

                        padding: "0 18px 0 22px",

                        borderBottom:
                            "1px solid rgba(255,255,255,.08)",

                        background:
                            "rgba(0,0,0,.08)",
							overflow:''
                    }}
                >

                    <div>

                        <div
                            style={{
                                color: "#ffffff",

                                fontSize: "18px",
                                fontWeight: 600
                            }}
                        >
                            Insight Detail
                        </div>

                        <div
                            style={{
                                marginTop: "2px",

                                color: "#7dd3fc",

                                fontSize: "11px",
                                fontWeight: 600,

                                letterSpacing: ".7px",
                                textTransform: "uppercase"
                            }}
                        >
                            Selected item
                        </div>

                    </div>

                    <button
                        type="button"

                        aria-label="Close detail drawer"

						onClick={() =>
						{
						    setEvidenceVisible(false);
						    setDetailVisible(false);
						}}

                        style={{
                            width: "36px",
                            height: "36px",

                            display: "flex",

                            alignItems: "center",
                            justifyContent: "center",

                            padding: 0,

                            border:
                                "1px solid rgba(255,255,255,.10)",

                            borderRadius: "50%",

                            background:
                                "rgba(255,255,255,.07)",

                            boxShadow:
                                "0 6px 16px rgba(0,0,0,.20)",

                            color: "#ffffff",

                            cursor: "pointer",

                            transition:
                                "background .2s ease, transform .2s ease"
                        }}

                        onMouseEnter={
                            function (event)
                            {
                                event.currentTarget.style.background =
                                    "rgba(90,155,214,.28)";

                                event.currentTarget.style.transform =
                                    "translateX(2px)";
                            }
                        }

                        onMouseLeave={
                            function (event)
                            {
                                event.currentTarget.style.background =
                                    "rgba(255,255,255,.07)";

                                event.currentTarget.style.transform =
                                    "translateX(0)";
                            }
                        }
                    >
                        <FontAwesomeIcon
                            icon={faChevronRight}
                        />
                    </button>

                </div>

                {/* DETAIL BODY */}

                <div
                    style={{
                        flex: 1,

                        minHeight: 0,

                        overflowY: "hidden",
                        overflowX: "hidden"
                    }}
                >
                    <WorkspaceInsightDetail
					onEvidenceRequested={() =>
					    {
					        setEvidenceVisible(true);
					    }}
					/>
                </div>

            </div>


            {/*==================================================
                LIST DRAWER

                This is always the front/right-hand drawer.
            ==================================================*/}

            <div
                style={{
                    position: "fixed",

                    top: 0,

                    right:
                        visible
                            ? "0px"
                            : "-" + LIST_WIDTH + "px",

                    width: LIST_WIDTH + "px",
                    height: "100vh",

                    display: "flex",
                    flexDirection: "column",

                    overflow: "visible",

                    background:
                        DRAWER_BACKGROUND,

                    backdropFilter:
                        "blur(14px)",

                    WebkitBackdropFilter:
                        "blur(14px)",

                    borderLeft:
                        "1px solid rgba(255,255,255,.07)",

                    boxShadow:
                        detailVisible
                            ? "-18px 0 55px rgba(0,0,0,.62)"
                            : "-12px 0 38px rgba(0,0,0,.52)",

                    transition:
                        TRANSITION,

                    zIndex: 5000,

                    color: "#ffffff"
                }}
            >

                {/* MAIN CLOSE HANDLE */}

                <button
                    type="button"

                    aria-label="Close investigation drawer"

                    onClick={closeWorkspace}

                    style={{
                        position: "absolute",

                        top: "50%",
                        left: "-23px",

                        width: "46px",
                        height: "46px",

                        display: "flex",

                        alignItems: "center",
                        justifyContent: "center",

                        padding: 0,

                        border:
                            "1px solid rgba(255,255,255,.10)",

                        borderRight: "none",

                        borderRadius: "30px",
                 

                        background:
                            "linear-gradient(180deg,#364152 0%,#1f2937 58%,#111827 100%)",

                        boxShadow:
                            "-8px 4px 20px rgba(0,0,0,.38)",

                        color: "#ffffff",

                        cursor: "pointer",

                        transform:
                            "translateY(-50%)",

                        transition:
                            "left .2s ease, background .2s ease"
                    }}

                    onMouseEnter={
                        function (event)
                        {
                            event.currentTarget.style.left =
                                "-28px";

                            event.currentTarget.style.background =
                                "linear-gradient(180deg,#5a9bd6 0%,#356ea1 100%)";
                        }
                    }

                    onMouseLeave={
                        function (event)
                        {
                            event.currentTarget.style.left =
                                "-23px";

                            event.currentTarget.style.background =
                                "linear-gradient(180deg,#364152 0%,#1f2937 58%,#111827 100%)";
                        }
                    }
                >
                    <FontAwesomeIcon
                        icon={faChevronRight}

                        style={{
                            fontSize: "15px"
                        }}
                    />
                </button>


                {/* LIST HEADER */}

                <div
                    style={{
                        minHeight: HEADER_HEIGHT + "px",

                        display: "flex",

                        alignItems: "center",
                        justifyContent: "space-between",

                        padding: "0 22px",

                        borderBottom:
                            "1px solid rgba(255,255,255,.08)",

                        background:
                            "rgba(0,0,0,.08)"
                    }}
                >

                    <div>

                        <div
                            style={{
                                color: "#ffffff",

                                fontSize: "18px",
                                fontWeight: 600
                            }}
                        >
                            High Priority Insights
                        </div>

                        <div
                            style={{
                                marginTop: "2px",

                                color: "#94a3b8",

                                fontSize: "11px",
                                fontWeight: 600,

                                letterSpacing: ".7px",
                                textTransform: "uppercase"
                            }}
                        >
                            12 results
                        </div>

                    </div>

                    <button
                        type="button"

                        aria-label="Open detail drawer"

                        onClick={() =>
                            setDetailVisible(true)}

                        style={{
                            width: "36px",
                            height: "36px",

                            display: "flex",

                            alignItems: "center",
                            justifyContent: "center",

                            padding: 0,

                            border:
                                "1px solid rgba(255,255,255,.10)",

                            borderRadius: "50%",

                            background:
                                detailVisible
                                    ? "linear-gradient(180deg,#5a9bd6 0%,#356ea1 100%)"
                                    : "rgba(255,255,255,.07)",

                            boxShadow:
                                "0 6px 16px rgba(0,0,0,.20)",

                            color: "#ffffff",

                            cursor: "pointer",

                            transition:
                                "background .2s ease, transform .2s ease"
                        }}

                        onMouseEnter={
                            function (event)
                            {
                                event.currentTarget.style.transform =
                                    "translateX(-2px)";
                            }
                        }

                        onMouseLeave={
                            function (event)
                            {
                                event.currentTarget.style.transform =
                                    "translateX(0)";
                            }
                        }
                    >
                        <FontAwesomeIcon
                            icon={faChevronLeft}
                        />
                    </button>

                </div>


                {/* LIST BODY */}

                <div
                    style={{
                        flex: 1,

                        minHeight: 0,

                        overflowY: "auto",
                        overflowX: "hidden"
                    }}
                >
                    <WorkspaceInsightsList
                        onInsightSelected={() =>
                            setDetailVisible(true)}
                    />
                </div>

            </div>

        </>

    );
}